import React from 'react';
export function FooterSection() {
  const currentYear = new Date().getFullYear();
  return <footer className="py-12 px-4 bg-forest-950 text-cream-200/50 border-t border-forest-800" data-id="element-34">
      <div className="max-w-4xl mx-auto text-center space-y-6 font-lora text-sm" data-id="element-35">
        <p className="leading-relaxed max-w-2xl mx-auto" data-id="element-36">
          Descargo de responsabilidad: La información contenida en este libro
          electrónico tiene fines educativos e informativos únicamente y no
          pretende sustituir el consejo, diagnóstico o tratamiento médico
          profesional. Siempre busque el consejo de su médico u otro proveedor
          de salud calificado con cualquier pregunta que pueda tener respecto a
          una condición médica.
        </p>

        <div className="w-12 h-px bg-forest-800 mx-auto" data-id="element-37"></div>

        <p data-id="element-38">
          &copy; {currentYear} Farmacia de Despensa. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}